const getRedirectUrl = function(redirectUrl) {
  if (redirectUrl.indexOf('127.0.0.1:85') > -1) {
    redirectUrl = redirectUrl.replace('127.0.0.1:85', location.host);
  }
  return redirectUrl;
};

const getDomainStr = function(resData){
  const { merchantTheme } = resData || '';
        const { webDomain } = merchantTheme || '';
        const domain = webDomain ? webDomain.replace(/www./i, '') : '';
        return domain ? domain[0].toUpperCase() + domain.substr(1) : '';
}

const getDomainFromUrlStr = function(){
  const href =  window.location.href;
  const reg = /[!^/](\/)/g;
  const domain = href.replace(reg, "").match(/\/(.+?)\//g);
  return domain ? true : false;
}

const getSeconds = function(startTime, endTime){
  return endTime - startTime
}


export { 
  getRedirectUrl,
  getDomainStr,
  getDomainFromUrlStr
};
